export enum CUSTOMER_STATUS {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  LIMITED = 'limited',
}
